import { RootState } from "../app/store";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { decodeToken } from "../util/helpers";
import { logout } from "../app/features/authSlice";

export const useCheckAuthToken = () => {
  const dispatch = useAppDispatch();

  const access_token = useAppSelector(
    (state: RootState) => state.auth.token.accessToken
  );

  // Validate AuthToken
  if (!access_token || access_token === undefined) {
    return false;
  } else {
    const decodedJwt = decodeToken(access_token);
    let currentDate = new Date();
    // if token expired
    if (decodedJwt.exp * 1000 <= currentDate.getTime()) {
      dispatch(logout());
      return false;
    }
    return true;
  }
};
